export enum TipoEmissorMensagem {
    "SISTEMA" = "SISTEMA",
    "CLIENTE" = "CLIENTE",
    "ATENDENTE_IA" = "ATENDENTE_IA",
    "ATENDENTE" = "ATENDENTE"
}